import { Controller } from "@hotwired/stimulus";

window.pagefind = require("../pagefind.js");

export default class extends Controller {
  static targets = [
    "container",
    "empty",
    "placeholder",
    "searching",
    "label",
    "input",
    "form",
  ];
  static values = { q: String };

  async connect() {
    await window.pagefind.options({
      baseUrl: "",
      bundlePath: "pagefind/",
      excerptLength: 0,
    });

    await window.pagefind.init();

    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);

      if (searchParams.has("q")) {
        const form = this.formTarget;

        if ("q" in form.elements) {
          form.elements.q.value = searchParams.get("q");
          this.search({ target: form });
        }
      }
    }
  }

  async search(event) {
    if (!this.hasContainerTarget) return;

    const form = event.target;
    const formData = new FormData(form);

    const q = formData.get("q") || null;

    this.qValue = q;
    this.formDisable(form, true);
    this.searchingTargets.forEach((x) => x.classList.remove("d-none"));

    // TODO: FormData como objeto
    this.searchResults = await window.pagefind.search(q);
    const count = this.searchResults.results.length;

    this.containerTarget.innerHTML = "";
    this.emptyTargets.forEach((x) => x.classList.add("d-none"));
    this.searchingTargets.forEach((x) => x.classList.add("d-none"));

    if (count) {
      const results = await this.resolveResults(this.searchResults.results);

      this.renderResults(results);
    } else {
      this.emptyTargets.forEach((x) => x.classList.remove("d-none"));
    }

    this.formDisable(form, false);
  }

  /*
   * Resuelve los datos de todos los resultados
   *
   * @param results [Array<Result>]
   * @return [Promise]
   */
  async resolveResults(results) {
    return await Promise.all(results.map((r) => r.data()));
  }

  async reset(event) {
    this.searchResults = null;
  }

  updateHistory() {
    const q = this.qValue;
    const query = new URLSearchParams({ q });

    window.history.pushState({ q }, q, `?${query.toString()}`);
  }

  formDisable(form, disable) {
    Array.from(form.elements).forEach((x) => (x.disabled = disable));
  }

  renderResults(results) {
    results.forEach((result) => this.renderResult(result));
  }

  renderResult(result) {
    const placeholder =
      this.placeholderTarget.content.firstElementChild.cloneNode(true);

    this.containerTarget.appendChild(placeholder);

    // TODO: Gestión de errores y cancelar peticiones
    fetch(result.meta.indexed)
      .then((response) => response.text())
      .then((body) => {
        const template = document.createElement("template");
        template.innerHTML = body;
        const result = template.content.firstElementChild;

        placeholder.replaceWith(result);
      })
      .catch(console.error);
  }
}
